// src/utils/isValidLicensePlate.ts
export const isValidLicensePlate = (plate: string): boolean => {
  return plate.length > 0;
};

